import { IconCash, IconPigMoney, IconCreditCard } from '@tabler/icons-react';

/**
 * Ledger type -> v3 category (icon-box tint + dot color) + Tabler glyph.
 * Single source for the type->icon mapping used by the Ledgers list, the
 * Dashboard, and the Ledger detail hero (#1123): 0 Checking, 1 Savings,
 * 2 Credit Card. Default to Checking for an unknown type.
 */
export const LEDGER_TYPE_CATEGORY = { 0: 'checking', 1: 'savings', 2: 'credit' };
export const LEDGER_TYPE_ICON = { 0: IconCash, 1: IconPigMoney, 2: IconCreditCard };

export const ledgerTypeCategory = (type) => LEDGER_TYPE_CATEGORY[type] || 'checking';
export const ledgerTypeIcon = (type) => LEDGER_TYPE_ICON[type] || IconCash;
